import { React, useState, useEffect, useRef } from 'react'
import { APIConstants, LoginConstants } from '../utilities/Constants'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

const VerifyOtp = ({ phoneNumber, onVerifySuccess, onClose }) => {

    
    const [showOtpModal, setshowOtpModal] = useState(false);
    const [timer, setTimer] = useState(10);
    const [otp, setOtp] = useState("");
    const [showResend, setShowResend] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const navigate = useNavigate();

    const userData = useSelector((state) => state.user.user);
        
    var userPracticeID = userData ? userData.practiceID : null;
    var userId = userData ? userData.userID : null;

    const otpInputRef = useRef(null);

    useEffect(() => {

        if (otpInputRef.current) {
            otpInputRef.current.focus();
        }
    }, []);

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            VerifyOtpToPhone();
        }
    };


    const sendOtpToPhone = async () => {
        try {

            const inputJson = {
                sUserID: userId,
                sPracticeID: userPracticeID,

            };

            const myInput = JSON.stringify(inputJson);
            const sInputJSON = JSON.stringify(myInput);
            const response = await fetch(APIConstants.SERVICES_URL + LoginConstants.SendOtp, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: sInputJSON,
            });
            if (!response.ok) throw new Error("Failed to send OTP");
            console.log("OTP sent successfully!", response);
        } catch (error) {
            console.error("Error sending OTP:", error);
        }
    };



    useEffect(() => {
        if (userId && userPracticeID) {
            sendOtpToPhone();
        }
    }, [userId, userPracticeID]);



    useEffect(() => {
        if (timer > 0) {

            const countdown = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);

            return () => clearInterval(countdown);
        } else {
            setShowResend(true);
        }
    }, [timer]);


    const handleResend = () => {

        console.log("OTP resent");
        setTimer(10);
        setShowResend(false);
    };



    const VerifyOtpToPhone = async () => {

        try {
            setLoading(true);
           
            const sPhoneNumber = userData.sPhoneNumber.replace(/[\s()-]/g, "");
            const PhoneNumber = "+1" + sPhoneNumber.replace(/^\+?1?/, "");

            const inputJson = {
                sCode: otp,
                sPhoneNumber: PhoneNumber,

            };

            const myInput = JSON.stringify(inputJson);
            const sInputJSON = JSON.stringify(myInput);
            const response = await fetch(APIConstants.SERVICES_URL + LoginConstants.VerifyOtp, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: sInputJSON,
            });
            if (!response.ok) throw new Error("Failed to send OTP");
            console.log("OTP Verify successfully!", response);

            const data = await response.json();
            console.log("API Response:", data);

            if (data?.status === "approved") {
                setMessage("OTP verified successfully.");

                setTimeout(() => {
                    setLoading(false);
                    navigate('/locations')
                }, 500);

            } else if (data?.status === "pending") {
                setMessage("Entered OTP is wrong/invalid. Please try again.");
            } else if (data?.status === "expired") {
                setMessage("Entered OTP is expired. Please try again.");
            } else {
                setMessage("Something went wrong. Please try again.");
            }
        } catch (error) {
            console.error("Error verifying OTP:", error);
            setMessage("Server error. Please try again.");
        } finally {
            setLoading(false);

        }
    };


    const handleCloseModals = () => {

        setshowOtpModal(false)
    };


    return (
        <>


            {userData?.sIsOTP == 1 && (
                <div class="otp-popup" style={{ background: " rgb(255, 255, 255)", padding: "24px", borderRadius: "16px", zIndex: 99999, width: "100%", maxWidth: "400px", boxShadow: "rgba(0, 0, 0, 0.3) 0px 0px 25px", boxSizing: "border-box", transition: " opacity 0.3s ease-in-out", opacity: 5, position: 'absolute', marginTop: '200px', marginLeft: '500px' }}>
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <div onClick={onClose} style={{ cursor: "pointer", fontSize: "25px", color: "#aaa", fontWeight: 'bold' }}>×</div>
                    </div>
                    <h5 style={{ margin: " 0 0 20px" }}>🔐 Verify OTP</h5>
                    <hr />
                    <div id="otpSentMessage" style={{ color: " #000", marginBottom: "12px", fontSize: "14px", minHeight: "18px" }}>OTP sent to <span style={{ color: "blue" }}>+1{userData.sPhoneNumber}</span>.<br /><span style={{ fontSize: "13px", color: "#666" }}>Not yours? Contact Admin.</span></div>
                    <div id="otpResend" style={{ color: "#000", marginBottom: "12px", fontSize: "14px", minHeight: "18px" }}>
                        {!showResend ? (
                            <>
                                Did not receive OTP yet? Resend in{" "}
                                <span id="resendTimer">{timer}</span>s
                            </>
                        ) : (
                            <span
                                style={{
                                    color: "blue",
                                    cursor: "pointer",
                                    fontWeight: "bold",
                                }}
                                onClick={handleResend}
                            >
                                Resend OTP
                            </span>
                        )}
                    </div>

                    {message && <p style={{ color: "red", marginTop: "10px" }}>{message}</p>}

                    <div id="otpMessage" style={{ marginBottom: "12px", fontSize: "14px", minHeight: "18px" }}></div>
                    <input type="text" id="otpInput" maxlength={4} placeholder="Enter 4-digit OTP" ref={otpInputRef}
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        onKeyDown={handleKeyPress}

                        style={{
                            width: "100%",
                            padding: "14px",
                            fontSize: "18px",
                            border: "1px solid #ccc",
                            borderRadius: "10px",
                            marginBottom: "20px",
                            textAlign: "center",
                            letterSpacing: "6px",
                            boxSizing: " border-box",
                        }} />
                    <button onClick={VerifyOtpToPhone} style={{ padding: "14px", backgroundColor: " rgb(76, 175, 80)", color: "white", border: "none", borderRadius: "10px", cursor: "pointer", fontSize: "16px", width: "100%", transition: "background-color 0.3s", }}>
                        Verify
                    </button>
                </div>
            )}

            {loading && (
                <div className="overlay">
                    <div className="spinner-container">
                        <div className="spinner-grow text-danger" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div className="spinner-grow text-warning" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div className="spinner-grow text-info" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            )}


        </>
    )
}

export default VerifyOtp
